import comp from "./SubjectBenchmarks";
export default comp;
